import {
  DEFAULT_LINK_EXTERNAL_REL,
  DEFAULT_LINK_EXTERNAL_TARGET, DEFAULT_LINK_INTERNAL_REL,
  DEFAULT_LINK_INTERNAL_TARGET,
  DEFAULT_LINK_REFERRER_POLICY,
} from '../../constants';
import { LinkingTypeEnum } from '../../dto/recs.dto';
import { HtmlElementContext, Nullable } from '../../types';

type Props = Nullable<Partial<Pick<HTMLAnchorElement, 'href'| 'rel' | 'referrerPolicy' | 'target' | 'className' | 'textContent'>> & {
  attributes?: Record<string, string | undefined | null>;
  linkingType?: LinkingTypeEnum;
}>;

export const linkElement = (props: Props, context: HtmlElementContext): HTMLAnchorElement => {
  const targetMapping: Record<LinkingTypeEnum | 'default', string> = {
    default: DEFAULT_LINK_EXTERNAL_TARGET,
    [ LinkingTypeEnum.INTERNAL ]: DEFAULT_LINK_INTERNAL_TARGET,
    [ LinkingTypeEnum.EXTERNAL ]: DEFAULT_LINK_EXTERNAL_TARGET,
  };

  const relAttributeMapping: Record<LinkingTypeEnum | 'default', string> = {
    default: '',
    [ LinkingTypeEnum.INTERNAL ]: DEFAULT_LINK_INTERNAL_REL,
    [ LinkingTypeEnum.EXTERNAL ]: DEFAULT_LINK_EXTERNAL_REL,
  };

  const referrerPolicyMapping: Record<LinkingTypeEnum | 'default', string> = {
    default: DEFAULT_LINK_REFERRER_POLICY,
    [ LinkingTypeEnum.INTERNAL ]: DEFAULT_LINK_REFERRER_POLICY,
    [ LinkingTypeEnum.EXTERNAL ]: DEFAULT_LINK_REFERRER_POLICY,
  }

  const element = context.dom.createElement('a');
  element.href = props.href ?? '';
  element.target = props.target ?? targetMapping[ props.linkingType ?? 'default' ];
  element.rel = props.rel ?? relAttributeMapping[ props.linkingType ?? 'default' ];
  element.referrerPolicy = props.referrerPolicy ?? referrerPolicyMapping[ props.linkingType ?? 'default' ];
  element.className = props.className ?? '';
  element.textContent = props.textContent ?? null;

  for (const [ key, value ] of Object.entries(props.attributes ?? {})) {
    element.setAttribute(key, value ?? '');
  }

  return element;
}
